import { useEffect, useState } from "react";
import Modal from "../modal/modal";

const Get_Blogs = () => {
  const [news, setNews] = useState([]);
  const [search, setSearch] = useState("");
  const [modalMessage, setModalMessage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNews = (page = 1) => {
    setLoading(true);
    setError(null);

    fetch(`/api/get_global_news.php?page=${page}&limit=20`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log("API Response:", data);
        if (data.success) {
          setNews(data.news || []);
          setTotalPages(data.totalPages || 1);
          setCurrentPage(page);
        } else {
          setError(data.message || "Unknown error");
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError(err.message);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchNews(1);
  }, []);

  // Модалка для удаления новости
  const confirmDelete = (id, title) => {
    setModalMessage({
      id,
      title: "Ցանկանում եք ջնջել այս նորությունը?",
      text: `Դուք ջնջելու եք "${title}" նորությունը`,
      actions: [
        {
          label: "Ջնջել",
          success: true,
          onClick: () => handleDelete(id),
        },
        {
          label: "Չեղարկել",
          success: false,
          onClick: () => setModalMessage(null),
        },
      ],
    });
  };

  // Удаление новости
  const handleDelete = (id) => {
    fetch(`/api/delete_blog.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ blog_id: id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setNews((prev) => prev.filter((n) => n.id !== id));
          fetchNews(currentPage);
        } else {
          alert("Անհաջող ջնջում: " + data.message);
        }
      })
      .catch((err) => alert("Սխալ: " + err))
      .finally(() => setModalMessage(null));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString("hy-AM");
  };

  // Фильтрация новостей
  const filtered = news.filter((n) => {
    const s = search.toLowerCase();
    const id = (n.id ?? "").toString().toLowerCase();
    const title = (n.title ?? "").toLowerCase();
    const companyName = (n.companyName ?? "").toLowerCase();
    const createdDate = formatDate(n.created_at).toLowerCase();

    return (
      id.includes(s) ||
      title.includes(s) ||
      companyName.includes(s) ||
      createdDate.includes(s)
    );
  });

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      fetchNews(newPage);
    }
  };

  if (loading) {
    return (
      <section>
        <div className="flex justify-center items-center h-64">
          <div className="text-white text-lg sm:text-xl">Բեռնվում է...</div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section>
        <div className="flex justify-center items-center h-64">
          <div className="text-red-400 text-lg sm:text-xl">Սխալ: {error}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="px-3 sm:px-4 md:px-6">
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          actions={modalMessage.actions}
        />
      )}

      {/* Заголовок и поиск */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
          Գլոբալ նորություններ
        </h1>

        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Որոնում..."
          className="w-full sm:w-72 px-4 py-2 rounded-lg bg-white/10 text-white placeholder-white/40 
                     border border-white/20 focus:outline-none focus:border-white 
                     transition text-sm sm:text-base"
        />
      </div>

      {/* Десктопная таблица */}
      <div className="hidden md:block overflow-x-auto rounded-lg border border-white/20 backdrop-blur-xl">
        <table className="min-w-full text-white border-collapse">
          <thead>
            <tr className="bg-white/10">
              <th className="py-3 px-4 border border-white/20 text-left">
                Նորության ID
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Վերնագիր
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Կազմակերպություն
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Տեղադրվել է
              </th>
              <th className="py-3 px-4 border border-white/20 text-left">
                Գործողություններ
              </th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((n) => (
              <tr
                key={n.id}
                className="hover:bg-white/5 transition border border-white/10"
              >
                <td className="py-3 px-4 border border-white/10">{n.id}</td>
                <td className="py-3 px-4 border border-white/10">
                  {n.title}
                </td>
                <td className="py-3 px-4 border border-white/10">
                  {n.companyName || "—"}
                </td>
                <td className="py-3 px-4 border border-white/10">
                  {formatDate(n.created_at)}
                </td>
                <td className="py-3 px-4 border border-white/10">
                  <button
                    onClick={() => confirmDelete(n.id, n.title)}
                    className="px-3 py-1 bg-red-600/50 hover:bg-red-600 rounded-lg border border-red-400/30 transition"
                  >
                    ջնջել
                  </button>
                </td>
              </tr>
            ))}

            {filtered.length === 0 && news.length === 0 && (
              <tr>
                <td
                  colSpan="5"
                  className="py-4 px-4 text-center text-white/50 border border-white/20"
                >
                  Նորություններ չկան
                </td>
              </tr>
            )}

            {filtered.length === 0 && news.length > 0 && (
              <tr>
                <td
                  colSpan="5"
                  className="py-4 px-4 text-center text-white/50 border border-white/20"
                >
                  Ոչինչ չի գտնվել
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Мобильные карточки */}
      <div className="md:hidden space-y-3">
        {filtered.map((n) => (
          <div
            key={n.id}
            className="bg-white/5 rounded-lg border border-white/20 p-4 space-y-2"
          >
            <div className="flex justify-between items-start gap-2">
              <span className="text-xs text-white/60">ID: {n.id}</span>
              <span className="text-xs text-white/60">{formatDate(n.created_at)}</span>
            </div>
            
            <h3 className="text-white font-medium text-sm sm:text-base break-words">
              {n.title}
            </h3>
            
            <p className="text-white/70 text-xs sm:text-sm">
              {n.companyName || "—"}
            </p>
            
            <button
              onClick={() => confirmDelete(n.id, n.title)}
              className="w-full px-3 py-2 bg-red-600/50 hover:bg-red-600 rounded-lg border border-red-400/30 transition text-white text-sm"
            >
              ջնջել
            </button>
          </div>
        ))}

        {filtered.length === 0 && news.length === 0 && (
          <div className="text-center text-white/50 py-8 bg-white/5 rounded-lg border border-white/20">
            Նորություններ չկան
          </div>
        )}

        {filtered.length === 0 && news.length > 0 && (
          <div className="text-center text-white/50 py-8 bg-white/5 rounded-lg border border-white/20">
            Ոչինչ չի գտնվել
          </div>
        )}
      </div>

      {/* Пагинация */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center mt-4 sm:mt-6 gap-2 sm:space-x-4">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-3 sm:px-4 py-1.5 sm:py-2 bg-white/10 hover:bg-white/20 rounded-lg border border-white/20 
                       disabled:opacity-50 disabled:cursor-not-allowed transition text-sm sm:text-base"
          >
            Նախորդ
          </button>

          <span className="text-white text-sm sm:text-base">
            Էջ {currentPage} / {totalPages}
          </span>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-3 sm:px-4 py-1.5 sm:py-2 bg-white/10 hover:bg-white/20 rounded-lg border border-white/20 
                       disabled:opacity-50 disabled:cursor-not-allowed transition text-sm sm:text-base"
          >
            Հաջորդ
          </button>
        </div>
      )}
    </section>
  );
};

export default Get_Blogs;